import { render, staticRenderFns } from "./Airswitch.vue?vue&type=template&id=1a30abc6&scoped=true&"
import script from "./Airswitch.vue?vue&type=script&lang=js&"
export * from "./Airswitch.vue?vue&type=script&lang=js&"
import style0 from "./Airswitch.vue?vue&type=style&index=0&id=1a30abc6&prod&scoped=true&lang=less&"
import style1 from "./Airswitch.vue?vue&type=style&index=1&id=1a30abc6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a30abc6",
  null
  
)

export default component.exports